/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import { Box, Card, CardContent, Divider, makeStyles, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import MergeAccount from './MergeAccount';
import UserDeleteAccount from './UserDeleteAccount';

const useStyles = makeStyles(theme => ({
  root: {
    minWidth: 275,
    padding: '1rem',
    marginBottom: '2rem',
    marginTop: '2rem',
  },
  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '0.5rem',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  title: {
    fontSize: '1.5rem',
    fontWeight: '500',
  },
  subtitle: {
    fontSize: '1.2rem',
    fontWeight: '400',
    maxWidth: '35rem',
    marginTop: theme.spacing(2),
  },
  button: {
    marginTop: theme.spacing(2),
  },
  divider: {
    marginBottom: '2.125rem',
  },
}));

function UserManageAccount() {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Card className={classes.root}>
      <CardContent>
        <Box className={classes.cardHeader}>
          <Typography className={classes.title} color="textPrimary" gutterBottom>
            {t('user.management.manage-account')}
          </Typography>
        </Box>

        <Divider className={classes.divider} />
        <MergeAccount />

        <Divider className={classes.divider} />
        <UserDeleteAccount />
      </CardContent>
    </Card>
  );
}

export default UserManageAccount;
